// Document taxonomy — mirrors Document::CATEGORIES_BY_GROUP on the backend.
// `scope` maps a UI scope tab to the category group used for filtering/labels.

export const CATEGORY_LABELS = {
  // Compliance (organization)
  rera: "RERA",
  financial: "Financial / Audit",
  agreement: "Brokerage Agreement",
  kyc: "KYC",
  // Project
  legal_title: "Legal & Title",
  govt_approval: "Govt. Approval",
  completion: "Completion (OC/CC)",
  marketing: "Marketing Collateral",
  // Transaction
  sales_allotment: "Sales / Allotment",
  booking: "Booking Confirmation",
  receipt: "Payment Receipt",
  demand_letter: "Demand Letter",
  quotation: "Quotation / Cost Sheet",
}

export const CATEGORY_GROUPS = {
  compliance: ["rera", "financial", "agreement", "kyc"],
  project: ["legal_title", "govt_approval", "completion", "marketing"],
  transaction: ["sales_allotment", "booking", "receipt", "demand_letter", "quotation"],
}

export const SCOPE_TABS = [
  { id: "all", label: "All", documentableType: null },
  { id: "organization", label: "Organization", documentableType: "Organization", group: "compliance" },
  { id: "projects", label: "Projects", documentableType: "Project", group: "project" },
  { id: "transactions", label: "Transactions", documentableType: null, group: "transaction" },
]

export function categoryLabel(category) {
  if (!category) return "Uncategorized"
  return CATEGORY_LABELS[category] || category
}

// Maps a content_type to a coarse file-kind for icon selection.
export function fileKind(contentType = "", fileName = "") {
  const ct = contentType.toLowerCase()
  const ext = fileName.split(".").pop()?.toLowerCase()
  if (ct.startsWith("image/")) return "image"
  if (ct.startsWith("video/") || ["mp4", "mov", "avi", "webm"].includes(ext)) return "video"
  if (ct.includes("pdf") || ext === "pdf") return "pdf"
  if (["doc", "docx"].includes(ext) || ct.includes("word")) return "doc"
  if (["xls", "xlsx", "csv"].includes(ext) || ct.includes("sheet") || ct.includes("excel")) return "sheet"
  return "file"
}

export function formatSize(bytes) {
  if (!bytes) return ""
  const kb = bytes / 1024
  if (kb < 1024) return `${Math.round(kb)} KB`
  return `${(kb / 1024).toFixed(1)} MB`
}

// Expiry status → badge styling + label.
export const EXPIRY_BADGE = {
  expired: { label: "Expired", className: "bg-red-50 text-red-700 ring-red-600/20" },
  expiring_soon: { label: "Expiring soon", className: "bg-amber-50 text-amber-700 ring-amber-600/20" },
  valid: { label: "Valid", className: "bg-emerald-50 text-emerald-700 ring-emerald-600/20" },
}
